import * as React from "react";
import { withActionsExecutor, ActionsExecutorPropsType, Action, ActionError } from "components/actions";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Button, Grid } from "components/controls/widget";
import YesNoDialog, { YesNoDialogProps } from "common/components/controls/YesNoDialog"
import Error from "common/components/controls/Error";
import apiOznameniHostovani from "common/api/SendEmailNotifications/OznameniHostDlouhodobe";
import { Hostovani, StornoHostovani as apiStornoHostovani } from "common/api/Evidence/Clenove/HostovaniDlouhodoba";
import HU from "common/utils/HostovaniDlouhodobaUtils";

interface StornovaniProps {
    hostovani: Hostovani;
    setHostovani: (hostovani: Hostovani) => void;
    je_to_host_klub: boolean;
}

interface State {
    showDialog: boolean;
    submitting?: boolean;
    hasError: boolean;
    error?: React.ReactNode;
}

type Props = StornovaniProps & State & ActionsExecutorPropsType;


const initialState: State = {
    showDialog: false,
    hasError: false,
}

class Stornovani extends React.PureComponent<Props & WithStyles<typeof styles>>{

    handleClose = (cancel: boolean) => {
        if (cancel) {
            this.showDialog(false);
        } else {
            const { executeAction, hostovani } = this.props
            const action1 = apiStornoHostovani(hostovani.id)
                .onSuccess(p => {
                    const action2 = apiOznameniHostovani()
                        .onSuccess(() => this.close(p))
                        .onError(() => this.close(p));
                    executeAction(action2, {}, { hostovaniId: p.id, typZpravy: HU.TypZpravy_Storno })
                })
                .onValidationFailed(e => this.setError(e['_error']))
                .onError(e => this.setError(e.message));

            executeAction(action1, { submitting: true, hasError: false, error: undefined });
        }
    }

    setError = (error: string | string[]) => {
        this.props.updateState({ submitting: false, hasError: true, error: error });
    }

    showDialog = (show: boolean) => {
        if (this.props.showDialog !== show) {
            this.props.updateState({ submitting: false, showDialog: show, hasError: false, error: undefined });
        }
    }

    close = (hostovani: Hostovani) => {
        this.showDialog(false);
        this.props.setHostovani(hostovani);
    }

    render() {
        const { showDialog, submitting, hostovani, je_to_host_klub, classes, hasError, error } = this.props;

        const dlgProps: YesNoDialogProps = {
            show: showDialog,
            submitting: submitting,
            handleClose: this.handleClose,
            title: 'Stornování dlouhodobého hostování',
            fullWidth: true,
            maxWidth: 'sm',
        }

        const stavOK = (hostovani.stav === HU.Stav_PotvrzeniICaDomKC || hostovani.stav === HU.Stav_ZaplaceniPopl);
        const zobrazit = (stavOK && je_to_host_klub);


        return zobrazit ? <div className={classes.root}>
            <Button color="danger" variant="contained" onClick={() => this.showDialog(true)}>{'Stornovat dlouhodobé hostování'}</Button>
            <YesNoDialog {...dlgProps}>
                <Grid container justify="space-between" direction="column" spacing={8}>
                    <Grid item>{'Opravdu chcete stornovat dlouhodobého hostování?'}</Grid>
                    {hasError && <Grid item><Error noPadding>{error}</Error></Grid>}
                </Grid>
            </YesNoDialog>
        </div> : null;
    }
}

export const styles = (theme: Theme) => createStyles({
    root: {
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
});

export default withStyles(styles)(withActionsExecutor<StornovaniProps, State>(initialState, Stornovani));